module.exports = __webpack_public_path__ + "img/gq.gq6c7f20b.svg";